import cn from "classnames";
import Button from "@ebsco-ui/button";
import { usePopoverContext } from "../popover-context";
import { PopoverButtonType } from "./interfaces";

const PopoverButton: PopoverButtonType = ({ children, className, ...rest }) => {
  const { getBlocksWith, handleOnClick, isOpen, uniqueName, buttonRef } =
    usePopoverContext();

  return (
    <Button
      ref={buttonRef}
      onMouseDown={(ev) => {
        ev.preventDefault();
        (ev.target as HTMLButtonElement).focus();
      }}
      className={cn(
        className,
        getBlocksWith("__button"),
        isOpen && getBlocksWith("__button--open"),
      )}
      aria-haspopup={true}
      aria-controls={`${uniqueName}-panel`}
      {...(isOpen && { "aria-expanded": true })}
      onClick={handleOnClick}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default PopoverButton;
